<template>
  <v-form v-model="valid" @submit.prevent="register">
    <!-- <v-text-field label="email" disabled v-model="userInvite.email"></v-text-field> -->
    <v-row no-gutters>
      <v-text-field
        outlined
        dense
        :value="userInvite.email"
        label="Email"
        name="email"
        prepend-inner-icon="mdi-email"
        type="text"
        autocomplete="username"
        disabled
      ></v-text-field>
    </v-row>

    <v-row no-gutters>
      <v-text-field
        outlined
        dense
        id="password"
        v-model="credentials.password"
        label="New password"
        name="password"
        prepend-inner-icon="mdi-lock"
        type="password"
        autocomplete="password"
        :rules="[formRules.required, formRules.passwordLength]"
      ></v-text-field>
    </v-row>

    <v-row no-gutters>
      <v-text-field
        outlined
        dense
        id="confirm-password"
        v-model="credentials.confirmPassword"
        label="Confirm new password"
        name="confirmPassword"
        prepend-inner-icon="mdi-lock"
        type="password"
        autocomplete="off"
        :rules="[
          formRules.required,
          credentials.password === credentials.confirmPassword ||
            'The password confirmation does not match.'
        ]"
      ></v-text-field>
    </v-row>

    <v-row no-gutters justify="center">
      <v-btn
        color="primary"
        type="submit"
        depressed
        :disabled="!valid"
        :loading="loading.confirmation"
      >
        Confirm your account
      </v-btn>
    </v-row>
  </v-form>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'UserInviteRegisterForm',
  props: {
    token: {
      type: String,
      required: true
    }
  },
  data: () => ({
    valid: false,
    credentials: {
      password: '',
      confirmPassword: ''
    },
    formRules: {
      required: v => !!v || 'This field is required.',
      passwordLength: v =>
        v.length > 9 || 'Password must have at least 10 characters.',
      email: v => /.+@.+\..+/.test(v) || 'Must be a valid email.'
    }
  }),
  computed: {
    ...mapState('register', ['userInvite', 'confirmation', 'loading'])
  },
  methods: {
    ...mapActions('register', ['confirmUserInvite']),
    register() {
      this.confirmUserInvite({
        id: this.userInvite.id,
        token: this.token,
        password: this.credentials.password
      }).then(() => {
        this.$router.push({ name: 'dashboard' })
      })
    }
  }
}
</script>
